import { Check } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, Overline } from "./Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-paper py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Overline>What we do</Overline>
        <h2 className="mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-navy sm:text-5xl">
          Four verticals. One accountable team.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600">
          Every service carries a transparent cost tag — and the reasoning behind it.
          No hidden line items, no vague quotations.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08}>
            <article
              data-testid={`service-card-${s.id}`}
              className="group flex h-full flex-col border border-slate-200 bg-white p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-navy hover:hard-shadow-sm sm:p-9"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-sm font-bold text-electric">{s.index}</span>
                <span className="h-2 w-2 rotate-45 bg-navy transition-colors group-hover:bg-electric" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-extrabold tracking-tight text-navy sm:text-3xl">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.blurb}</p>

              <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {s.types.map((t) => (
                  <li key={t} className="flex items-start gap-2 text-xs font-semibold text-slate-700">
                    <Check size={14} className="mt-0.5 shrink-0 text-electric" />
                    {t}
                  </li>
                ))}
              </ul>

              <div className="mt-auto pt-7">
                <div className="border-t border-dashed border-slate-300 pt-5">
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Cost Tag</p>
                  <p className="mt-1.5 font-mono text-base font-bold text-navy" data-testid={`service-cost-${s.id}`}>
                    {s.cost}
                  </p>
                  <p className="mt-1 font-mono text-[11px] leading-relaxed text-slate-500">{s.costNote}</p>
                  <p className="mt-3 border-l-2 border-electric pl-3 text-xs italic leading-relaxed text-slate-500">
                    {s.justification}
                  </p>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
